import { types } from "mobx-state-tree";

export const emotionModel = types.model("emotion_model", {
  _id: types.optional(types.string, ""),
  emotion_text: types.optional(types.string, ""),
  emoji_text: types.optional(types.string, ""),
  emotion_value: types.optional(types.number, 1),
  mood: types.optional(types.string, ""),
});
